//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { WebsiteScriptCodeDisplayItem } from './WebsiteScriptCodeDisplayItem';
import { SocialMediaLinkDisplayItem } from './SocialMediaLinkDisplayItem';
import { WebsitePageDisplayItem } from './WebsitePageDisplayItem';
import { WebsiteRenderContextDisplayItem } from './WebsiteRenderContextDisplayItem';
import { WebsiteSocialLinksLocation, WebsiteTemplate, WebsiteHostingType } from './Enums';

export class WebsiteDisplayItem extends ItemBase {
    ID: string | null = null;
    SchoolID: string | null = null;
    Url: string | null = null;
    Hostname: string | null = null;
    Title: string | null = null;
    AccentColor: string | null = null;
    BackgroundColor: string | null = null;
    HeaderColor: string | null = null;
    FooterColor: string | null = null;
    HeadingFontFamily: string | null = null;
    BodyFontFamily: string | null = null;
    ScriptCodes: WebsiteScriptCodeDisplayItem[] = [];
    SocialMediaLinks: SocialMediaLinkDisplayItem[] = [];
    SocialLinksLocation: WebsiteSocialLinksLocation = WebsiteSocialLinksLocation.All;
    HeaderLogoUrl: string | null = null;
    HeaderLogoMediaLibraryItemID: string | null = null;
    Template: WebsiteTemplate | null = null;
    HostingType: WebsiteHostingType = WebsiteHostingType.ExternallyHosted;
    WebsitePages: WebsitePageDisplayItem[] = [];
    RenderContext: WebsiteRenderContextDisplayItem | null = null;

    constructor(initializer?: Partial<WebsiteDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "WebsiteDisplayItem";
}
